import React from 'react';
import { ListGroupItem, Input } from 'reactstrap';
export const FilterFormCheckbox = (props) => {
    return (<ListGroupItem key={props.checkboxData}>
        <div className="custom-control custom-checkbox">
            <Input
                type="checkbox"
                className="custom-control-input m-0"
                component="input"
                name={props.checkboxData}
                id={props.checkboxData}
                checked={props.checkboxCheckedValue}
                onChange={props.checkboxCallback}
            />
            <label className="custom-control-label mb-1" title={props.checkboxData} htmlFor={props.checkboxData}>{props.checkboxData}</label>
        </div>
    </ListGroupItem>)
}